export default "__VITE_ASSET__wCCVAas7__"